var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    id: "Bulb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37ae51",
    d: "M77 97v10h-4v3h-3.5l-1.1 2.3c-.7 1.6-2.3 2.6-4.1 2.6s-3.4-1-4.1-2.6l-1.1-2.3H55v-3h-4V97h26m1.7-4H49.9c-1.7 1-2.9 1.7-2.9 3.5v10.8c0 1.9 1.3 3.7 3.1 3.7h1.1c0 2 1.1 3 2.5 3h2.7c1.3 3 4.3 5.1 7.8 5.1s6.4-2.1 7.8-5.1h2.8c1.4 0 2.5-1 2.5-3h1.1c1.9 0 2.5-1.8 2.5-3.7V96.5c.1-1.8-.6-3.5-2.2-3.5z",
    className: "color2c3e50 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3bd35c",
    d: "M64.3 16c8.3 0 16.4 3.6 22.2 9.7 12.6 13.2 12.6 31.7 0 44.3-6 6-9.2 12-10.8 17H52.9c-1.6-4-4.7-10.7-10.9-17-12.6-12.5-12.6-31.1 0-44.3 6-6.3 13.9-9.7 22.3-9.7m0-4c-9.5 0-18.5 3.9-25.2 11C25 37.8 25 58.7 39.2 72.9 45.6 79.3 48.7 86 49.9 91h28.7v.2c1.3-5 4.3-11.8 10.7-18.2 14.2-14.2 14.3-35.2.1-50-6.6-7-15.7-11-25.1-11z",
    className: "color3b97d3 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37ae51",
    d: "M75.8 55.8c-.4-.4-1-.4-1.4 0L64.1 66 53.7 55.6c-.4-.4-1-.4-1.4 0s-.4 1-.1 1.4L63 67.8v14.1c0 .6.4 1 1 1s1-.4 1-1V67.8l10.7-10.7c.4-.3.5-1 .1-1.3z",
    className: "color2c3e50 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.19d44a0a9d023a6d6d12099bb6725082.svg";
export { ForwardRef as ReactComponent };